import * as React from 'react';
import Component from '../../../../Component';
import AEmployee from '../../../../Components/AEmployee';

export default class Item extends Component {
    render() { return (<tr><td><AEmployee employee={this.props.employee} /></td></tr>); }
}